var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralEmotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18C11.3869 18 13.6761 17.0518 15.364 15.364C17.0518 13.6761 18 11.3869 18 9C18 6.61305 17.0518 4.32387 15.364 2.63604C13.6761 0.948212 11.3869 0 9 0C6.61305 0 4.32387 0.948212 2.63604 2.63604C0.948212 4.32387 0 6.61305 0 9C0 11.3869 0.948212 13.6761 2.63604 15.364C4.32387 17.0518 6.61305 18 9 18ZM7.875 7.3125C7.875 8.244 7.371 9 6.75 9C6.129 9 5.625 8.244 5.625 7.3125C5.625 6.381 6.129 5.625 6.75 5.625C7.371 5.625 7.875 6.381 7.875 7.3125ZM4.5 11.8125C4.5 11.6633 4.55926 11.5202 4.66475 11.4148C4.77024 11.3093 4.91332 11.25 5.0625 11.25H12.9375C13.0867 11.25 13.2298 11.3093 13.3352 11.4148C13.4407 11.5202 13.5 11.6633 13.5 11.8125C13.5 11.9617 13.4407 12.1048 13.3352 12.2102C13.2298 12.3157 13.0867 12.375 12.9375 12.375H5.0625C4.91332 12.375 4.77024 12.3157 4.66475 12.2102C4.55926 12.1048 4.5 11.9617 4.5 11.8125ZM11.25 9C10.629 9 10.125 8.244 10.125 7.3125C10.125 6.381 10.629 5.625 11.25 5.625C11.871 5.625 12.375 6.381 12.375 7.3125C12.375 8.244 11.871 9 11.25 9Z",
    fill: "#6F7494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralEmotion);
export default __webpack_public_path__ + "static/media/Neutral-Emotion.089f0084c4e79c73a032a254c063afc5.svg";
export { ForwardRef as ReactComponent };